// fix image slideru
$(document).ready(()=>{
    const w = $("#image-slider").width();
    $("#image-slider-control").attr("max",w);
    $("#image-slider-control").attr("value", Math.round(w/2));
    $('#image-slider .slider-button').css('left', (Math.round(w/2) - 12 - 6*(Math.round(w/2)/w)) + "px");
})

$(window).resize(()=>{
    const w = $("#image-slider").width();
    $("#image-slider-control").attr("max",w);
    $("#image-slider-control").attr("value", Math.round(w/2));
    $('#image-slider .slider-button').css('left', (Math.round(w/2) - 12 - 6*(Math.round(w/2)/w)) + "px");
})

$('#image-slider-control').on('input change', (e) => {
	let sliderPos = e.target.value;
    const w = $("#image-slider").width();
    
	$('#image-slider .slider-button').css('left', (sliderPos - 12 - 6*(sliderPos/w)) + "px");
	$('#image-slider .after').css('width', sliderPos + "px");
})  

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        console.log("nacteno z cache");
        prepareFavourites();
        updateAmount(window.favourites.size)
        checkFavourites()
        isInFavourite();
    }
});

window.favourites = new Map();
window.replaceFavourites = (selector = "") => {
    $(selector + " .product-in .add-to-favourite").each((index, el)=>{
        const id = $(el).data("id");
        if (window.favourites.has(id)) {
            $(el).removeClass("add-to-favourite-empty");
            $(el).addClass("favourite-active");
        } else {
            $(el).addClass("add-to-favourite-empty");
            $(el).removeClass("favourite-active");
        }
    });
}

window.onPopupLoad = (id) => {
    if (window.favourites.has(id)) {
        $('.product-popup .favourites').addClass('favourite-active');
        $('.product-popup .favourites .text').text('Aus Wunschliste entfernen');
    } else {
        $('.product-popup .favourites').removeClass('favourite-active');
        $('.product-popup .favourites .text').text('Zur Wunschliste hinzufügen');
    }
};

// klik v cardu
$('html').on('click', '.add-to-favourite', function (e) {
    const el = $(this);
    const id = $(el).data("id");
    if (el.hasClass("add-to-favourite-empty")) {
        el.removeClass("add-to-favourite-empty")
    } else {
        el.addClass("add-to-favourite-empty")
    }
    createNewFavouriteFromCard(el,id,e);
})

function createNewFavouriteFromCard(el, id, e) {
    $parent = el.closest('.product-in');
	
    newFavourite = {
        title: $parent.find('.name').first().next().text().trim(),
        link: $parent.find("a.image").attr("href"),
        image: $parent.find("img").attr("src"),
        price: $parent.find('.final-price').html().trim(),
        id: id
    }

    if (newFavourite.title == "")
        $parent.find(".name").text()

    addToFavourites(newFavourite);

	checkFavourites()
}


prepareFavourites();
updateAmount(window.favourites.size)
checkFavourites()
isInFavourite();
window.replaceFavourites();

function prepareFavourites() {
    if (!localStorage.favourites)
        return;

    const parsed = JSON.parse(localStorage.favourites);
    // console.log(parsed);

    // cleanup ze stare verze, kde nebyly idecka
    for (let i = 0; i < parsed.length; i++) {
        // kontrola jenom na sudych kvuli implementaci mapy
        if (i % 2 == 0)
            continue;
        if (parsed[i].length != 2) {
            localStorage.clear();
            return;
        }
    }


    window.favourites = new Map(parsed);
    // console.log(window.favourites);
}

// pokud uzivatel klikne na oblibene v detailu produktu/popupu
$('html').on('click', '.product-form__addToFavourite', function (e) {
	e.preventDefault()
	$this = $(this)
	$parent = $this.closest('.p-info-wrapper')
	if (!localStorage.favourites) {
		localStorage.favourites = JSON.stringify([])
	}
	newFavourite = {
		title: $parent.find('h1.title').text().trim(),
		link: $(this).closest('.product-popup').length ? $parent.siblings('.p-image-wrapper').find('a').attr('href') : window.location.pathname,
		image: $($parent.siblings('.p-image-wrapper').find(".p-mini-images .cardImage img")[0]).attr('src'),
		price: $parent.find('.price').html().trim(),
        id: parseInt($parent.find(".product-id").text()),
	}

    addToFavourites(newFavourite);

    // musime tlacitko prekreslit
    if (window.favourites.has(newFavourite.id)) {
        $($parent).find('.product-form__addToFavourite').addClass('favourite-active');
        $($parent).find('.product-form__addToFavourite .text').text('Aus Wunschliste entfernen');
    } else {
        $($parent).find('.product-form__addToFavourite').removeClass('favourite-active');
        $($parent).find('.product-form__addToFavourite .text').text('Zur Wunschliste hinzufügen');
    }
    window.replaceFavourites();
})

// kontrola na strance produktu
function isInFavourite() {
    const id = $(".main-product .product-id").text();
    if (window.favourites.has(parseInt(id))) {
        $('.main-product .product-form__addToFavourite').addClass('favourite-active');
        $('.main-product .product-form__addToFavourite .text').text('Aus Wunschliste entfernen');
    } else {
        $('.main-product .product-form__addToFavourite').removeClass('favourite-active');
        $('.main-product .product-form__addToFavourite .text').text('Zur Wunschliste hinzufügen');
    }
}

function addToFavourites(newFavourite) {
    prepareFavourites();
    if (window.favourites.has(newFavourite.id))
        window.favourites.delete(newFavourite.id);
    else
        window.favourites.set(newFavourite.id,newFavourite)
    
    updateAmount(window.favourites.size);

	checkFavourites();
    saveToLocalStorage();
}

function updateAmount(amount = 0) {
	if (amount != 0) {
		$('.favourite-button').addClass('favourite-full')
		$('.favourite-button i').text(amount)
	} else {
		$('.favourite-button').removeClass('favourite-full')
		$('.favourite-button i').text('')
	}
}

function saveToLocalStorage() {
    const str = JSON.stringify(Array.from(window.favourites.entries()));
    localStorage.favourites = str;
}

function checkFavourites() {
	if (window.location.href.indexOf('/pages/Lieblings') != -1) {
		html = '<h4>Leere</h4>'
        html = '<div class="products products-block">'
        window.favourites.forEach((item, key) => {
            link = item.link.indexOf('/products/') != -1 ? item.link.split('/products/')[1] : item.link
            html +=
                '<div class="product">' +
                '<div class="product-in">' +
                '<header>' +
                '<a class="image" href="' +
                item.link +
                '"><img src="' +
                item.image +
                '"></a>' +
                '<a class="show-in-popup product-detail-popup" data-mfp-src=".product-popup" data-has-photo-upload="false" data-rating-count="" data-rating="" data-difficulty="" data-handle="' +
                link +
                '" href="javascript:void(0)" tabindex="-1">' +
                '<svg class="zoom-in-icon" enable-background="new 0 0 39.8 39.8" version="1.1" viewBox="0 0 39.8 39.8" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">' +
                '<path class="dark-transparent" d="m35.8 39.8h-31.8c-2.2 0-4-1.8-4-4v-31.8c0-2.2 1.8-4 4-4h31.8c2.2 0 4 1.8 4 4v31.8c0 2.2-1.8 4-4 4z"></path>' +
                '<path class="white" d="m29.5 27.9-4.1-4.1c1.1-1.5 1.8-3.3 1.8-5.3 0-4.8-3.9-8.6-8.6-8.6-4.8 0-8.6 3.9-8.6 8.6s3.9 8.6 8.6 8.6c1.9 0 3.7-0.6 5.2-1.7l4.1 4.1c0.2 0.2 0.5 0.3 0.8 0.3s0.6-0.1 0.8-0.3c0.4-0.4 0.4-1.1 0-1.6zm-10.9-2.1c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3c0 4.1-3.3 7.3-7.3 7.3z"></path>' +
                '<path class="white" d="m22.8 18.5c0 0.5-0.4 0.8-0.8 0.8h-2.6v2.7c0 0.5-0.4 0.8-0.8 0.8s-0.8-0.4-0.8-0.8v-2.6h-2.6c-0.5 0-0.8-0.4-0.8-0.8 0-0.5 0.4-0.8 0.8-0.8h2.6v-2.6c0-0.5 0.4-0.8 0.8-0.8s0.8 0.4 0.8 0.8v2.6h2.6c0.5-0.1 0.8 0.3 0.8 0.7z"></path>' +
                '</svg>' +
                '</a>' +
                '</header>' +
                '<section>' +
                '<a class="name" href="' +
                item.link +
                '">' +
                item.title +
                '</a>' +
                '<div class="add-to-favourite favourite-active" data-id="' + item.id + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" class="heart"><defs><symbol id="heart"><path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"></path></symbol></defs><use xlink:href="#heart" x="0" y="0"></use></svg>' +
                '</div>' +
                '</section>' +
                '<footer>' +
                '<div class="add-to-cart product-detail-popup" data-has-photo-upload="false" data-mfp-src=".product-popup" data-rating-count="" data-rating="" data-difficulty="" data-handle="' +
                link +
                '">' +
                '<a class="btn btn-conversion" tabindex="-1">' +
                '<svg class="add-to-cart-icon" enable-background="new 0 0 39.8 39.8" version="1.1" viewBox="0 0 39.8 39.8" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">' +
                '<path class="dark-transparent" d="m35.8 39.8h-31.8c-2.2 0-4-1.8-4-4v-31.8c0-2.2 1.8-4 4-4h31.8c2.2 0 4 1.8 4 4v31.8c0 2.2-1.8 4-4 4z"></path>' +
                '<path class="white" d="m15.2 24.3 1-1.1h0.1l12.1-1.3c0.3 0 0.5-0.3 0.6-0.6l1-8.3c0-0.2 0-0.4-0.1-0.5s-0.3-0.2-0.5-0.2l-17.4-0.6-1.2-3c-0.1-0.2-0.3-0.4-0.5-0.4l-4.2-0.4h-0.1c-0.1 0-0.3 0-0.4 0.1s-0.2 0.3-0.2 0.4c0 0.2 0 0.3 0.1 0.5 0.1 0.1 0.3 0.2 0.4 0.2l3.8 0.4 5.4 12.9-0.9 1c-0.3 0.4-1.4 1.6-0.9 2.7 0.4 1 1.8 1 2 1h13.4c0.4 0 0.6-0.3 0.6-0.6 0-0.4-0.3-0.6-0.6-0.6h-13.4c-0.2 0-0.5-0.1-0.7-0.2l-0.1-0.1v-0.2c0-0.1 0.2-0.5 0.7-1.1zm-2.7-11.3h0.4l15.8 0.5-0.9 7.2-11.5 1.2-3.8-8.9z"></path>' +
                '<path class="white" d="m26.8 28.1c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4-1.1-2.4-2.4-2.4zm0 3.5c-0.6 0-1.1-0.5-1.1-1.1s0.5-1.1 1.1-1.1 1.1 0.5 1.1 1.1-0.5 1.1-1.1 1.1z"></path>' +
                '<path class="white" d="m15.7 28.1c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4c-0.1-1.3-1.1-2.4-2.4-2.4zm0 3.5c-0.6 0-1.1-0.5-1.1-1.1s0.5-1.1 1.1-1.1 1.1 0.5 1.1 1.1c-0.1 0.6-0.5 1.1-1.1 1.1z"></path>' +
                '</svg>' +
                '</a>' +
                '</div>' +
                '<div class="price-wrapper">' +
                '<span class="final-price">' +
                item.price +
                '</span>' +
                '</div>' +
                '<div class="availability">' +
                '<span class="in-stock">' +
                '<span class="hide-on-small">Lieferung in  </span>1-3 Werktagen</span>' +
                '</div>' +
                '</footer>' +
                '</div>' +
                '</div>'
        })
        html += '</div>'
		$('#content article .container').html('<h1>Lieblings</h1>' + html)
	}

    window.replaceFavourites();
}
